import React from 'react';
import { styled } from '@linaria/react';
import { PdLocked, PdUnlocked } from '@vio/atlas-assets';
export interface Props {
  /** Whether the Lock is opened or closed */
  isLocked?: boolean;
  /** The size of the lock */
  size?: number;
  /** The color of the lock */
  color?: string;
}
const _exp = /*#__PURE__*/() => ({
  size
}) => size;
const WrapperElement = /*#__PURE__*/styled('span')({
  name: "WrapperElement",
  class: "w1egk3pm",
  propsAsIs: false,
  vars: {
    "w1egk3pm-0": [_exp(), "px"]
  }
});
export const Lock = ({
  isLocked = true,
  size = 16,
  color = 'currentColor'
}: Props) => {
  return <WrapperElement size={size}>
      {isLocked ? <PdLocked size={size} color={color} /> : <PdUnlocked size={size} color={color} />}
    </WrapperElement>;
};

require("./Lock.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Lock.tsx");